import { render, staticRenderFns } from "./EventPageSelector.vue?vue&type=template&id=439ae8ac&scoped=true"
import script from "./EventPageSelector.vue?vue&type=script&lang=js"
export * from "./EventPageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ae8ac",
  null
  
)

export default component.exports